import React from 'react';

const SocialYoutube = () => {
  return (
    <svg id="elements_social-youtube.svg" data-name="elements/social-youtube.svg" xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 60 60">
      <path className="cls-1 bgFill" d="M4232,1870a30,30,0,1,1-30-30A30,30,0,0,1,4232,1870Z" transform="translate(-4172 -1840)" />
      <path className="cls-2 innerFill" d="M4202.01,1857.99H4202s-7.56,0-12.61.36a5.237,5.237,0,0,0-3.61,1.51,7.627,7.627,0,0,0-1.43,3.53,52.917,52.917,0,0,0-.36,5.75v2.7a53.161,53.161,0,0,0,.36,5.75,7.627,7.627,0,0,0,1.43,3.53,6.239,6.239,0,0,0,3.98,1.52c2.88,0.27,12.25.35,12.25,0.35h0s7.57-.01,12.61-0.37a5.2,5.2,0,0,0,3.61-1.5,7.627,7.627,0,0,0,1.43-3.53,53.161,53.161,0,0,0,.36-5.75v-2.7a52.917,52.917,0,0,0-.36-5.75,7.627,7.627,0,0,0-1.43-3.53,5.221,5.221,0,0,0-3.61-1.51c-5.04-.36-12.61-0.36-12.61-0.36m-3.72,17.11,9.73-4.97-9.74-5.01Z" transform="translate(-4172 -1840)" />
    </svg>
  );
};

export default SocialYoutube;
